import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  FormGroup,
  Divider,
  MenuItem,
  TextField,
  CircularProgress,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useEffect, useState } from 'react'
import './style.css'
import UserService from '../../../../services/UserService'
import { formatCpf } from '../../../../utils/formatCpf'
import { getAddress } from '../../../../services/getAddress'
import { CustomSnackbar, severityType } from '../../../../utils/alert'
import { MuiTelInput } from 'mui-tel-input'
import attendantApi from '../../../../services/api/attendant'
import clientApi, { findByPhone } from '../../../../services/api/client'
import attendanceApi from '../../../../services/api/attendance'
import briefingApi from '../../../../services/api/briefing'
import { client, useClient } from '../../../../contexts/ClientContext'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import styles from './FormGroupRegister.module.css'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';


import {
  TextFieldProps,
  VivaTextField,
  commonInputStyles,
} from '../TextField/TextField'
import { validators } from '@/utils/validators/validators'
import { delay } from '@/utils/delay'
import { formatPhone } from '@/utils/formatphone'
import parsePhoneNumberFromString from 'libphonenumber-js'

interface RegisterFormsProps {
  isUpdateMode: boolean
}

interface ValidationErrors {
  nome?: string
  email?: string
  origem?: string
  telefone?: string
  cep?: string
  cepEntrega?: string
  cpf?: string
  dataNascimento?: string
}

export function FormGroupRegister({ isUpdateMode }: RegisterFormsProps) {
  const [pessoaJuridica, setPessoaJuridica] = useState(false)
  const [alertInfo, setAlertInfo] = useState<{
    severity: severityType
    message: string
  }>({ severity: 'success', message: '' })
  const [showAlert, setShowAlert] = useState(false)
  const [isDifferent, setIsDifferent] = useState(false)
  const [errors, setErrors] = useState<ValidationErrors>({})

  const clientContext = useClient()

  const [clientFound, setClientFound] = useState<any>(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState<React.ReactNode>('');
  const [telefoneJaExiste, setTelefoneJaExiste] = useState(false);

  const [client, setClient] = useState<client>(clientContext.client)
  const [origemValor, setOrigemValor] = useState<string>('')
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('Setando Origem:', client.dadosPessoais.origem);
  
    // Verificar se a origem recebida está nas opções válidas
    const origemRecebida = client.dadosPessoais.origem?.toUpperCase();
    
    // Se estiver nas opções, usa o valor recebido
    if (origemOptions.includes(origemRecebida)) {
      setOrigemValor(origemRecebida);
    } else {
      setOrigemValor('');  // Setando para "" que vai mostrar o "Selecione"
    }
  }, [client.dadosPessoais.origem]);
  

  useEffect(() => {
    setIsDifferent(clientContext.client.enderecoEntrega != undefined)
    setClient(clientContext.client)
    setClient({
      ...clientContext.client,
      dadosPessoais: {
        ...clientContext.client.dadosPessoais,
        cpf: formatCpf(clientContext.client.dadosPessoais.cpf ?? ''),
      },
    })

    setPessoaJuridica(
      clientContext.client.dadosPessoais.cnpj != undefined &&
      clientContext.client.dadosPessoais.cnpj != ''
    )
  }, [clientContext.client])

  function handleAlertClose() {
    setShowAlert(false)
  }

  const removeFormatting = (formattedPhone: string) => {
    return formattedPhone.replace(/\D/g, '') // Remove todos os caracteres que não são dígitos
  }

  const prepareDataForSubmission = () => {
    const dataClient = {
      id: client.id,
      nome: client.dadosPessoais.nome,
      telefone: removeFormatting(client.dadosPessoais.telefone), // Use formatted telefone
      email: client.dadosPessoais.email || null,
      origem: client.dadosPessoais.origem || null,
      cpf: client.dadosPessoais.cpf?.trim() ? removeFormatting(client.dadosPessoais.cpf) : null,
      cnpj: client.dadosPessoais.cnpj?.trim() ? removeFormatting(client.dadosPessoais.cnpj) : null,
      dataNascimento: pessoaJuridica
      ? client.dadosPessoaJuridica?.dataFundacao
        ? new Date(client.dadosPessoaJuridica.dataFundacao).toISOString()
        : null
      : client.dadosPessoais.dataNascimento
      ? new Date(client.dadosPessoais.dataNascimento).toISOString()
      : null,
      inscricaoEstadual: client.dadosPessoaJuridica?.inscricaoEstadual,
      isentoInscricaoEstadual: client.dadosPessoaJuridica
        ?.inscricaoEstadualIsento
        ? true
        : false,
    }

    const dataAddress = client.endereco?.cep
      ? {
        id: client.endereco?.id,
        cep: client.endereco?.cep,
        rua: client.endereco?.rua,
        numero: client.endereco?.numero,
        complemento: client.endereco?.complemento || null, // Enviar como null se estiver vazio
        bairro: client.endereco?.bairro,
        cidade: client.endereco?.cidade,
        estado: client.endereco?.estado,
      }
      : null

    const dataDeliveryAddress = client.enderecoEntrega?.cep
      ? {
        id: client.enderecoEntrega?.id,
        cep: client.enderecoEntrega?.cep,
        rua: client.enderecoEntrega?.rua,
        numero: client.enderecoEntrega?.numero,
        complemento: client.enderecoEntrega?.complemento || null, // Enviar como null se estiver vazio
        bairro: client.enderecoEntrega?.bairro,
        cidade: client.enderecoEntrega?.cidade,
        estado: client.enderecoEntrega?.estado,
      }
      : null

    return {
      dataClient: {
        ...dataClient,
      },
      dataAddress: dataAddress 
        ? {
          ...dataAddress,
        } : null,
      deliveryAddress: dataDeliveryAddress
        ? {
          ...dataDeliveryAddress,
        }
        : null,
    }
  }

  async function handleSearch(cep: string) {
    try {
      const addressData = await getAddress(cep) // Aguarda a promessa ser resolvida
      // Preenche os campos de endereço com os dados retornados
      if (addressData.erro) {
        setAlertInfo({
          severity: 'error',
          message: 'O CEP não foi encontrado. Por favor preencha o endereço.',
        })
        setShowAlert(true)
      }

      setClient({
        ...client,
        endereco: {
          ...client.endereco,
          cep: addressData.cep,
          rua: addressData.logradouro,
          numero: '',
          complemento: '',
          bairro: addressData.bairro,
          cidade: addressData.localidade,
          estado: addressData.uf,
        },
      })
    } catch (err) {
      console.log('Erro ao buscar endereço')
    }
  }

  async function handleSearchDeliveryAddress(cep: string) {
    try {
      const addressData = await getAddress(cep)

      if (addressData.erro) {
        setAlertInfo({
          severity: 'error',
          message: 'O CEP não foi encontrado. Por favor preencha o endereço.',
        })
        setShowAlert(true)
      }
      setClient({
        ...client,
        enderecoEntrega: {
          ...client.enderecoEntrega,
          cep: addressData.cep,
          rua: addressData.logradouro,
          numero: '',
          complemento: '',
          bairro: addressData.bairro,
          cidade: addressData.localidade,
          estado: addressData.uf,
        },
      })
    } catch (err) {
      console.error('Erro ao buscar endereço:', err)
    }
  }

  const handleCepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCep = e.target.value
    setClient({
      ...client,
      endereco: {
        ...client.endereco,
        cep: newCep,
      },
    })

    if (removeFormatting(newCep).length === 8) {
      handleSearch(newCep)
    }
  }

  const handleDeliveryCepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCep = e.target.value
    setClient({
      ...client,
      enderecoEntrega: {
        ...client.enderecoEntrega,
        cep: newCep,
      },
    })

    if (removeFormatting(newCep).length === 8) {
      handleSearchDeliveryAddress(newCep)
    }
  }

  function handleDadosPessoaisChange(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    let { name, value } = event.target

    if (name == 'cpf') value = formatCpf(value)

    setClient({
      ...client,
      dadosPessoais: {
        ...client.dadosPessoais,
        [name]: value,
      },
    })
  }

  function handleDadosPessoaJuridaChange(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const { name, value, checked } = event.target

    if (name == 'inscricaoEstadualIsento')
      setClient({
        ...client,
        dadosPessoaJuridica: {
          ...client.dadosPessoaJuridica,
          inscricaoEstadualIsento: checked,
          inscricaoEstadual: checked ? undefined : client.dadosPessoaJuridica?.inscricaoEstadual,
          dataFundacao: client.dadosPessoaJuridica?.dataFundacao
        },
      })
    else
      setClient({
        ...client,
        dadosPessoaJuridica: {
          ...client.dadosPessoaJuridica,
          [name]: value,
        },
      })
  }

  function handleEnderecoChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target
    setClient({
      ...client,
      endereco: {
        ...client.endereco,
        [name]: value,
      },
    })
  }

  function handleEnderecoEntregaChange(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const { name, value } = event.target
    setClient({
      ...client,
      enderecoEntrega: {
        ...client.enderecoEntrega,
        [name]: value,
      },
    })
  }

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value, type, checked } = event.target

    if (name === 'tipo') {
      setPessoaJuridica(value === 'pessoaJuridica')
    } else {
      if (name === 'stateRegistrationExempt') {
        setClient({
          ...client,
          dadosPessoaJuridica: {
            ...client.dadosPessoaJuridica,
            inscricaoEstadualIsento: checked ? true : false,
          },
        })
      } else {
        setClient({
          ...client,
          dadosPessoais: {
            ...client.dadosPessoais,
            [name]: type === 'checkbox' ? checked : value,
          },
        })
      }
    }
  }

  function handleBlur(
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    validators?: ((value?: string) => string | undefined)[]
  ) {
    let { name, value } = event.target

    if (validators) {
      for (const validator of validators) {
        if (name === 'cpf') {
          value = removeFormatting(value)
        }

        const error = validator(value)
        setErrors((prevErrors) => ({ ...prevErrors, [name]: error }))
        if (error) {
          break
        }
      }
    }
  }

  function validate() {
    for (const campo of todosCampos) {
      
      if (!pessoaJuridica) {
        if (campo.validators) {
          for (const validator of campo.validators) {
            campo.value = client.dadosPessoais[campo.name as keyof typeof client.dadosPessoais];
            if (campo.name === 'cpf') campo.value = removeFormatting(campo.value);

            const error = validator(campo.value)

            setErrors((prevErrors) => ({
              ...prevErrors,
              [campo.name ?? '']: error,
            }))

            if (error) {
              console.warn(`Erro encontrado no campo ${campo.name}:`, error);
              return false;
            }
          }
        }
      } else {
        // Para Pessoa Jurídica, ignorar validação de CPF e Data de Nascimento
        if (campo.name !== 'cpf' && campo.name !== 'dataNascimento') {
          if (campo.validators) {
            for (const validator of campo.validators) {
              campo.value = client.dadosPessoais[campo.name as keyof typeof client.dadosPessoais];
  
              const error = validator(campo.value);
              setErrors((prevErrors) => ({
                ...prevErrors,
                [campo.name ?? '']: error,
              }));
  
              if (error) {
                console.warn(`Erro encontrado no campo ${campo.name}:`, error);
                return false;
              }
            }
          }
        }
      }
    }
  
    let validaTelefone = client.dadosPessoais.telefone;
    if (validaTelefone.startsWith('+55')) {
      validaTelefone = validaTelefone.slice(3);
    }

    if (!validaTelefone || validaTelefone.length < 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        telefone: 'Telefone inválido.',
      }))
      return false
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      telefone: validators.required(client.dadosPessoais.telefone),
    }))
    setErrors((prevErrors) => ({
      ...prevErrors,
      telefone: validators.minLength(3, client.dadosPessoais.telefone),
    }))

    if (errors.telefone) return false

    return true
  }

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    const validarTelefone = await validarTelefoneAsync(client.dadosPessoais.telefone);

    if (!validarTelefone || telefoneJaExiste) {
      setAlertInfo({
          severity: 'error',
          message: 'Número de telefone já existe. Por favor, altere o telefone ou verifique o cliente existente.',
      });
      setShowAlert(true);
      return;
    }

    const tempErrors: ValidationErrors = {}

    // Validação de Origem
    if (origemValor === "Selecione" || !origemValor) {
      tempErrors.origem = "Por favor, selecione uma origem válida.";
    }

    if (!validate()) {
      console.warn('Erro de validação')
      setErrors((prevErrors) => ({ ...prevErrors, ...tempErrors })) // Adiciona os erros de validação ao estado
      return
    }

    if (Object.keys(tempErrors).length > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, ...tempErrors })) // Adiciona os erros de CPF ao estado
      return
    }
    setLoading(true);

    // Se não houver erros, procede com a submissão
    try {
      const res = await clientApi.create(prepareDataForSubmission())
      console.log('Resposta da API:', res)
      await handleCreateAttendance(res.data.response.cliente.id)
      setAlertInfo({
        severity: 'success',
        message: 'Cliente cadastrado com sucesso',
      })
      setShowAlert(true)
      clientContext.reloadClientes()
      await delay(2500)
      setShowAlert(false)
      resetForm()
      localStorage.removeItem('clientData')

    } catch (err) {
        console.error("Erro ao cadastrar cliente:", err);
      
        // Verifica se o erro tem a estrutura de `AxiosResponse`
        if (err && typeof err === "object" && "status" in err && "data" in err) {
          console.error("Erro na requisição dentro do if:", err);
      
          if (err.status === 400 || err.status === 422) {
            setAlertInfo({
              severity: "error",
              message: err.data.message,
            });
          } else {
            setAlertInfo({
              severity: "error",
              message: "Houve um erro ao cadastrar o cliente, tente novamente",
            });
          }
        } else {
          console.error("Erro não identificado:", err);
          setAlertInfo({
            severity: "error",
            message: "Houve um erro inesperado, tente novamente",
          });
        }
        setShowAlert(true);
        await delay(2500);
        setShowAlert(false);
      } finally {
        setLoading(false);
      }
  }

  const resetForm = () => {
    clientContext.resetClient()
    setPessoaJuridica(false)
    setIsDifferent(false)
    setErrors({})
  }

  async function handlerUpdate() {
    if (!validate()) {
      return
    }

    const id = prepareDataForSubmission().dataClient.id
    const data = prepareDataForSubmission()

    if (validate() && id) {
      // updateClient
      setLoading(true);
      try {
        // remove origem antes de atualizar
        const { origem, ...dataClientSemOrigem } = data.dataClient;
        const updatedClient = await clientApi.updateClient(id, {
          ...data,
          dataClient: dataClientSemOrigem,
        });
        console.log('Resposta da API:', updatedClient)

        if (updatedClient.status === 200) {
          setAlertInfo({
            severity: 'success',
            message: 'Cliente atualizado com sucesso',
          })
          setShowAlert(true)

          clientContext.reloadClientes()
          await delay(2500)
          setShowAlert(false)
        } else {
          console.log('erro: ', updatedClient)
        }

      } catch (err) {
        console.error("Erro ao atualizar cliente:", err);
      
        // Verifica se o erro tem a estrutura de `AxiosResponse`
        if (err && typeof err === "object" && "status" in err && "data" in err) {
          console.error("Erro na requisição dentro do if:", err);
      
          if (err.status === 400 || err.status === 422) {
            setAlertInfo({
              severity: "error",
              message: err.data.message,
            });
          } else {
            setAlertInfo({
              severity: "error",
              message: "Houve um erro ao atualizar o cliente, tente novamente",
            });
          }
        } else {
          console.error("Erro não identificado:", err);
          setAlertInfo({
            severity: "error",
            message: "Houve um erro inesperado, tente novamente",
          });
        }
        setShowAlert(true);
        await delay(2500);
        setShowAlert(false);
      } finally {
        setLoading(false);
      }
    }
  }

  async function handleCreateAttendance(client_id: number) {
    try {
      const userId = UserService.getUser()?.userId

      if (userId == null || userId == undefined)
        throw new Error('Não há informação de userId')

      const attendant = await attendantApi.getAttendantByUserId(userId)

      if (attendant.status == 500)
        throw new Error('Erro ao recuperar atendente: ' + attendant)

      if (attendant.data == null || attendant.data == undefined) {
        throw new Error(
          'Erro ao recuperar dados do atendente, atendente provavelmente não existe com este id'
        )
      }

      const attendance = await attendanceApi.createAttendance(
        client_id,
        attendant.data.id
      )

      if (attendance.status == 500)
        throw new Error('Erro ao criar atendimento: ' + attendance)

      const briefing = await briefingApi.createBriefing(attendance.data.id)

      if (briefing.status == 500 || !briefing.data)
        throw new Error('Erro ao criar briefing: ' + briefing)

      setClient({
        ...client,
        briefingId: briefing.data.id,
      })
    } catch (err) {
      throw err
    }
  }

  const handleCheckboxChange = (event: any) => {
    setIsDifferent(event.target.checked)
    setClient({
      ...client,
      enderecoEntrega:
        event.target.checked && clientContext.client.enderecoEntrega
          ? clientContext.client.enderecoEntrega
          : event.target.checked && !client.enderecoEntrega
            ? {
              id: undefined,
              cep: '',
              rua: '',
              numero: '',
              complemento: '',
              bairro: '',
              cidade: '',
              estado: '',
            }
            : undefined,
    })
  }

  function phoneInput() {
    const validarTelefone = (telefone: string) => {
      console.log('Validando telefone:', telefone);
      try {
        const apenasNumeros = telefone.replace(/\D/g, "");
        
        if (apenasNumeros.startsWith("55")) {
          formatPhone(telefone); // Validação BR
        } else {
          // Validação internacional
          if (!/^\d{8,15}$/.test(apenasNumeros)) {
            throw new Error("Número internacional inválido.");
          }
        }
    
        return true;
      } catch (error) {
        return false;
      }
    };
  
    const formatTelefoneParaInput = (telefone: string) => {
      const apenasNumeros = telefone.replace(/\D/g, "");
      if (!apenasNumeros) return "";
    
      const parsed = parsePhoneNumberFromString(`+${apenasNumeros}`);
      return parsed?.formatInternational() || `+${apenasNumeros}`;
    };
  
    return (
      <MuiTelInput
        InputLabelProps={{
          shrink: true,
          style: commonInputStyles,
        }}
        InputProps={{
          style: { height: 40, width: '15rem' },
          inputProps: { maxLength: 25 },
        }}
        FormHelperTextProps={{
          sx: {
            margin: 0.5,
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'pre-wrap',
          },
        }}
        defaultCountry="BR"
        forceCallingCode
        required={true}
        helperText={errors.telefone}
        error={!!errors.telefone}
        label="Telefone"
        value={formatTelefoneParaInput(client.dadosPessoais.telefone)}
        onChange={(e) => {
          // Atualiza o valor do telefone, limpa o erro e redefine `telefoneJaExiste`
          setClient((prevClient) => ({
            ...prevClient,
            dadosPessoais: {
              ...prevClient.dadosPessoais,
              telefone: e,
            },
          }));
          setErrors((prevErrors) => ({ ...prevErrors, telefone: undefined }));
          setTelefoneJaExiste(false); // Redefine para permitir o cadastro se o número está sendo alterado
        }}
        onBlur={async () => {
          const telefoneAtual = client.dadosPessoais.telefone;

          if (!validarTelefone(telefoneAtual)) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              telefone: "Digite um número válido.",
            }));
            return;
          } else {
            setErrors((prevErrors) => ({ ...prevErrors, telefone: undefined }));
          }
  
          let formattedPhone = telefoneAtual;
          if (telefoneAtual.replace(/\D/g, "").startsWith("55")) {
            formattedPhone = formatPhone(telefoneAtual);
          }
  
          // Atualiza o valor do cliente no estado com o telefone formatado
          setClient((prevClient) => ({
            ...prevClient,
            dadosPessoais: { ...prevClient.dadosPessoais, telefone: formattedPhone },
          }));
  
          // Validação assíncrona para verificar duplicidade somente no onBlur
          const telefoneExiste = await validarTelefoneAsync(formattedPhone);
          if (!telefoneExiste) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              telefone: "Número de telefone já existe.",
            }));
            setTelefoneJaExiste(true); // Define como `true` se o telefone já existe
          }
        }}
      />
    );
  }

  const validarTelefoneAsync = async (telefone: string) => {
    try {
      const response = await findByPhone(telefone);
  
      if (response?.data?.id && response.data.id !== client.id) {
        const clientName = response.data.nome;
  
        setDialogMessage(
          <>
            Já existe um cliente com o número de telefone informado: <strong>{clientName}</strong>.
          </>
        );
        setClientFound(response.data); // Salvando os dados do cliente encontrado
        setOpenDialog(true); // Abre o dialog
        setTelefoneJaExiste(true);
  
        return false; // O telefone já existe
      }
  
      setTelefoneJaExiste(false);
      return true;
  
    } catch (error) {
      // Se a API não encontrar um cliente, consideramos o telefone como disponível
      setTelefoneJaExiste(false);
      return true;
    }
  };

  const camposEndereco: TextFieldProps[] = [
    { label: 'Endereço', name: 'rua', maxLength: 150 },
    { label: 'Número', name: 'numero', maxLength: 10, width: '5rem' },
    { label: 'Complemento', name: 'complemento', maxLength: 120 },
    { label: 'Bairro', name: 'bairro', maxLength: 50 },
    { label: 'Cidade', name: 'cidade', maxLength: 30 },
    { label: 'Estado', name: 'estado', maxLength: 30, width: '5rem' },
  ]

  const camposEnderecoEntrega: TextFieldProps[] = [
    { label: 'Endereço', name: 'rua', maxLength: 150 },
    { label: 'Número', name: 'numero', maxLength: 10, width: '5rem' },
    { label: 'Complemento', name: 'complemento', maxLength: 120 },
    { label: 'Bairro', name: 'bairro', maxLength: 50 },
    { label: 'Cidade', name: 'cidade', maxLength: 30 },
    { label: 'Estado', name: 'estado', maxLength: 30, width: '5rem' },
  ]

  const origemOptions = [
    'LINK', 'ADS', 'META', 'PRESENCIAL', 'INDICAÇÃO', 
    'EMAIL', 'EVENTO', 'ANÚNCIO', 'YOUTUBE', 'INSTAGRAM', "CAMPANHA", "INDICACAO DE CORRETORES"
  ];

  // Todo: ver md
  const camposPessoaFisica: TextFieldProps[] = [
    {
      label: 'CPF',
      name: 'cpf',
      maxLength: 14,
      minWidth: '10rem',
      width: '10rem',
      error: !!errors.cpf,
      helperText: errors.cpf,
      validators: [validators.isCpf],
      value: client.dadosPessoais.cpf,
    },
    {
      label: 'Data de Nascimento',
      name: 'dataNascimento',
      type: 'date',
      maxLength: 8,
      width: '10rem',
      minWidth: '10rem',
      validators: [validators.isAdult],
      error: !!errors.dataNascimento,
      helperText: errors.dataNascimento,
      value: client.dadosPessoais.dataNascimento
        ? new Date(client.dadosPessoais.dataNascimento)
          .toISOString()
          .split('T')[0]
        : '',
    },
    {
      label: 'Telefone',
      name: 'telefone',
      maxLength: 25,
      customField: phoneInput,
      error: !!errors.telefone,
      helperText: errors.telefone,
      required: true,
    },
    {
      label: 'E-mail',
      name: 'email',
      maxLength: 250,
      validators: [
        validators.isEmail,
        () => {
          return validators.minLength(3)
        },
      ],
      error: !!errors.email,
      helperText: errors.email,
    },
    ...(!isUpdateMode
      ? [
          {
            label: 'Origem',
            type: 'select',
            name: 'origem',
            width: '12rem',
            minWidth: '12rem',
            value: origemValor,
            onChange: handleDadosPessoaisChange,
            select: true,
            error: !!errors.origem,
            helperText: errors.origem,
            customField: () => (
              <TextField
                select
                label="Origem"
                className={styles.selectField}
                name="origem"
                value={origemValor || "Selecione"}
                onChange={handleDadosPessoaisChange}
                error={!!errors.origem}
                helperText={errors.origem}
                onBlur={() => {
                  errors.origem = '';
                }}
              >
                <MenuItem value="Selecione" disabled>
                  Selecione
                </MenuItem>
                {origemOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            ),
          },
        ]
      : []),
  ]

  const camposPessoaJuridica: TextFieldProps[] = [
    {
      label: 'CNPJ',
      name: 'cnpj',
      maxLength: 18,
      minWidth: '10rem',
      onChange: handleDadosPessoaisChange,
      value: client.dadosPessoais.cnpj,
      validators: [validators.isCnpj],
    },
    {
      label: 'Data de Fundação',
      name: 'dataFundacao',
      type: 'date',
      maxLength: 8,
      width: '10rem',
      minWidth: '10rem',
      value: client.dadosPessoaJuridica?.dataFundacao
        ? new Date(client.dadosPessoaJuridica.dataFundacao)
          .toISOString()
          .split('T')[0]
        : undefined,
    },
    {
      label: 'Telefone',
      name: 'telefone',
      maxLength: 25,
      customField: phoneInput,
      error: !!errors.telefone,
      helperText: errors.telefone,
      required: true,
    },
    {
      label: 'E-mail',
      name: 'email',
      maxLength: 250,
      onChange: handleDadosPessoaisChange,
      validators: [
        validators.isEmail,
        () => {
          return validators.minLength(3)
        },
      ],
      error: !!errors.email,
      helperText: errors.email,
      value: client.dadosPessoais.email ?? '',
      onBlur: (e) => {
        setErrors((prevErrors) => ({ ...prevErrors, email: undefined }));
      },
    },
    ...(!isUpdateMode
      ? [
          {
            label: 'Origem',
            type: 'select',
            name: 'origem',
            width: '12rem',
            minWidth: '12rem',
            value: origemValor,
            onChange: handleDadosPessoaisChange,
            select: true,
            error: !!errors.origem,
            helperText: errors.origem,
            customField: () => (
              <TextField
                select
                label="Origem"
                className={styles.selectField}
                name="origem"
                value={origemValor || "Selecione"}
                onChange={handleDadosPessoaisChange}
                error={!!errors.origem}
                helperText={errors.origem}
                onBlur={() => {
                  errors.origem = '';
                }}
              >
                <MenuItem value="Selecione" disabled>
                  Selecione
                </MenuItem>
                {origemOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            ),
          },
        ]
      : []),
    {
      label: 'Inscrição Estadual',
      name: 'inscricaoEstadual',
      maxLength: 15,
      width: '10rem',
      disabled: client.dadosPessoaJuridica?.inscricaoEstadualIsento,
    },
  ]

  const todosCampos = [
    ...camposPessoaFisica,
    ...camposPessoaJuridica,
    ...camposEndereco,
    ...camposEnderecoEntrega,
  ]

  async function criaNovoAtendimento(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    e.preventDefault()

    if (client.id === null || client.id === undefined) {
      throw new Error(
        'Erro ao recuperar dados do atendente, atendente provavelmente não existe com este id'
      )
    }

    try {
      await handleCreateAttendance(client.id)

      setAlertInfo({
        severity: 'success',
        message: 'Atendimento cadastrado com sucesso',
      })
      setShowAlert(true)

      clientContext.reloadClientes()
      await delay(1500)
      setShowAlert(false)
    } catch (error) {
      setAlertInfo({
        severity: 'error',
        message: 'Houve um erro ao cadastrar novo atendimento, tente novamente',
      })
      setShowAlert(true)

      clientContext.reloadClientes()
      await delay(1500)
      setShowAlert(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form_container}>
      <CustomSnackbar
        open={showAlert}
        severity={alertInfo.severity}
        message={alertInfo.message}
        handleClose={handleAlertClose}
      />

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Cliente já existente</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Já existe um cliente com o número de telefone "<strong>{clientFound?.telefone}</strong>".<br />
            <br />
            Cliente:{" "}
            {clientFound && (
              <a
                href={`/homepage?cliente=${clientFound.id}`} // Passa o clientId como query parameter
                target="_blank" // Abre em uma nova aba
                style={{ textDecoration: "underline" }}
              >
                <strong>{clientFound.nome}</strong>
              </a>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <div className={styles.form_fields_container}>
        <div className={styles.dados_pessoais_cliente}>
          <div>
            <span>Dados Pessoais do Cliente</span>
          </div>

          <div className={styles.container_campos_dados_pessoais}>
            <div className='section-divider'>
              <RadioGroup
                row
                name='tipo'
                value={pessoaJuridica ? 'pessoaJuridica' : 'pessoaFisica'}
                onChange={handleChange}
                className='radioInputContainer'
              >
                <FormControlLabel
                  value='pessoaFisica'
                  control={<Radio sx={{
                    color: '#4C4E64DE', '&.Mui-checked': {
                      color: '#666CFF',
                    },
                  }} />}
                  label='Pessoa Física'
                />
                <FormControlLabel
                  value='pessoaJuridica'
                  control={<Radio sx={{
                    color: '#4C4E64DE', '&.Mui-checked': {
                      color: '#666CFF',
                    },
                  }} />}
                  label='Pessoa Jurídica'
                />
              </RadioGroup>
            </div>

            <div className={styles.campos_dados_pessoais}>
              <VivaTextField
                label='Nome Completo'
                maxLength={150}
                name='nome'
                value={client.dadosPessoais.nome}
                onChange={handleDadosPessoaisChange}
                onBlur={(e) =>
                  handleBlur(e, [
                    validators.required,
                    () => {
                      return validators.maxLength(150)
                    },
                  ])
                }
                error={!!errors.nome}
                required={true}
                helperText={errors.nome}
              />

              {/* campos de contato */}
              {!pessoaJuridica ? (camposPessoaFisica.map((campo) => (
                <VivaTextField
                  {...campo}
                  value={
                    campo.value ??
                    client.dadosPessoais[
                      campo.name as keyof typeof client.dadosPessoais
                    ] ?? ''
                  }
                  onChange={handleDadosPessoaisChange}
                  onBlur={(e) =>
                    handleBlur(e, campo.validators ? campo.validators : undefined)
                  }
                />
              ))) :
                (
                  <>
                    {camposPessoaJuridica.map((campo) => (
                      <VivaTextField
                        {...campo}
                        value={
                          campo.value ??
                          (client.dadosPessoaJuridica
                            ? client.dadosPessoaJuridica[
                            campo.name as keyof typeof client.dadosPessoaJuridica
                            ]
                            : undefined)
                        }
                        onChange={campo.onChange ?? handleDadosPessoaJuridaChange}
                      />
                    ))}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={client.dadosPessoaJuridica?.inscricaoEstadualIsento}
                          onChange={handleDadosPessoaJuridaChange}
                          name='inscricaoEstadualIsento'
                        />
                      }
                      label='Isento'
                    />
                  </>
                )
              }
            </div>
          </div>
        </div>

        <Divider sx={{ width: '100%', marginTop: '0.625rem', marginBottom: '0.625rem' }} />

        <div className={styles.dados_endereco_cliente}>
          <div className={styles.subtitulto}>
            <span>Endereço do Cliente</span>
          </div>

          <div className={styles.dados_endereco}>
            <VivaTextField
              label="CEP"
              name="cep"
              value={client.endereco?.cep}
              width="10rem"
              onChange={(e) => {
                let newCep = e.target.value.replace(/\D/g, ""); // Remove tudo que não é número

                if (newCep.length > 8) return; // Limita a entrada a no máximo 8 dígitos numéricos

                // Insere o hífen após o quinto dígito, se necessário
                if (newCep.length > 5) {
                  newCep = newCep.slice(0, 5) + "-" + newCep.slice(5);
                }

                setClient({
                  ...client,
                  endereco: {
                    ...client.endereco,
                    cep: newCep,
                  },
                });

                // Remove o erro de CEP enquanto o usuário digita se estiver completo
                if (newCep.length === 9) {
                  setErrors((prevErrors) => ({ ...prevErrors, cep: undefined }));
                  handleSearch(newCep.replace("-", "")); // Busca quando o CEP está completo
                }
              }}
              onBlur={(e) => {
                let formattedCep = e.target.value.replace(/\D/g, ""); // Remove tudo que não é número
                if (formattedCep.length === 0) {
                  // Permite que o campo seja deixado em branco sem erro
                  setErrors((prevErrors) => ({ ...prevErrors, cep: undefined }));
                  return;
                }

                if (formattedCep.length === 8) {
                  // Formata e realiza a busca se o campo estiver completo
                  formattedCep = formattedCep.slice(0, 5) + "-" + formattedCep.slice(5);
                  setClient({
                    ...client,
                    endereco: {
                      ...client.endereco,
                      cep: formattedCep,
                    },
                  });
                  handleSearch(formattedCep.replace("-", ""));
                  setErrors((prevErrors) => ({ ...prevErrors, cep: undefined }));
                } else {
                  // Define o erro se o campo estiver com formato incorreto e preenchido
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    cep: "CEP incompleto ou incorreto",
                  }));
                }
              }}
              error={!!errors.cep}
              helperText={errors.cep}
            />
            {camposEndereco.map((campo) => (
              <VivaTextField
                {...campo}
                value={
                  client.endereco
                    ? client.endereco[
                      campo.name as keyof typeof client.endereco
                    ]?.toString()
                    : ''
                }
                onChange={handleEnderecoChange}
                onBlur={(e) =>
                  handleBlur(e, campo.validators ? campo.validators : undefined)
                }
                error={
                  campo.name === 'cep'
                    ? !!errors.cep
                    : !!errors[campo.name as keyof ValidationErrors]
                }
                helperText={
                  campo.name === 'cep'
                    ? errors.cep
                    : errors[campo.name as keyof ValidationErrors]
                }
              />
            ))}
          </div>

        </div>


        <div className='section-divider'>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<RadioButtonUncheckedIcon
                    sx={{
                      color: '#4C4E64DE'
                    }}
                  />}
                  checkedIcon={<RadioButtonCheckedIcon
                    sx={{
                      color: '#666CFF'
                    }}
                  />}
                  checked={isDifferent}
                />}
              label='O endereço de entrega é diferente do endereço pessoal'
              onChange={handleCheckboxChange}
            />
          </FormGroup>
        </div>
        {client.enderecoEntrega && (
          <div className={styles.dados_endereco_cliente}>
            <div className={styles.subtitulto}>
              <span>Endereço de entrega</span>
            </div>

            <div className={styles.dados_endereco}>
              <VivaTextField
                label="CEP"
                maxLength={9} // Permite até 9 caracteres para incluir o hífen
                width="10rem"
                name="cepEntrega"
                value={client.enderecoEntrega?.cep}
                onChange={(e) => {
                  let newCep = e.target.value.replace(/\D/g, ""); // Remove todos os caracteres não numéricos

                  if (newCep.length > 8) return; // Limita a entrada a no máximo 8 dígitos numéricos

                  // Insere o hífen após o quinto dígito, se necessário
                  if (newCep.length > 5) {
                    newCep = newCep.slice(0, 5) + "-" + newCep.slice(5);
                  }

                  setClient({
                    ...client,
                    enderecoEntrega: {
                      ...client.enderecoEntrega,
                      cep: newCep,
                    },
                  });

                  // Remove o erro de CEP de entrega enquanto o usuário digita
                  if (newCep.length === 9) {
                    setErrors((prevErrors) => ({ ...prevErrors, cepEntrega: undefined }));
                    handleSearchDeliveryAddress(newCep.replace("-", "")); // Busca quando completo
                  }
                }}
                onBlur={(e) => {
                  let formattedCep = e.target.value.replace(/\D/g, ""); // Remove todos os caracteres não numéricos
                  if (formattedCep.length === 8) {
                    // Formata o CEP e adiciona o hífen
                    formattedCep = formattedCep.slice(0, 5) + "-" + formattedCep.slice(5);

                    setClient({
                      ...client,
                      enderecoEntrega: {
                        ...client.enderecoEntrega,
                        cep: formattedCep,
                      },
                    });

                    handleSearchDeliveryAddress(formattedCep.replace("-", ""));

                    // Remove o erro se o CEP estiver completo e formatado corretamente
                    setErrors((prevErrors) => ({ ...prevErrors, cepEntrega: undefined }));
                  } else {
                    // Define o erro se o campo estiver vazio ou com formato incorreto
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      cepEntrega: "CEP incompleto ou incorreto",
                    }));
                  }
                }}
                error={!!errors.cepEntrega}
                required={true}
                helperText={errors.cepEntrega}
              />
              {camposEnderecoEntrega.map((campo) => (
                <VivaTextField
                  {...campo}
                  value={
                    client.enderecoEntrega
                      ? client.enderecoEntrega[
                        campo.name as keyof typeof client.enderecoEntrega
                      ]?.toString()
                      : ''
                  }
                  onChange={handleEnderecoEntregaChange}
                  onBlur={(e) =>
                    handleBlur(e, campo.validators ? campo.validators : undefined)
                  }
                  error={
                    campo.name === 'cepEntrega'
                      ? !!errors.cepEntrega
                      : !!errors[campo.name as keyof ValidationErrors]
                  }
                  helperText={
                    campo.name === 'cepEntrega'
                      ? errors.cepEntrega
                      : errors[campo.name as keyof ValidationErrors]
                  }
                  name={campo.name}
                  required={true}
                />
              ))}
            </div>

          </div>
        )}
        <div className={styles.section_divider}>
          <Button
            variant='contained'
            disableElevation
            className={styles.buttonRegisterCliente}
            onClick={isUpdateMode ? handlerUpdate : undefined}
            type={isUpdateMode ? 'button' : 'submit'}
            sx={{
              height: '2.5rem',
              width: '14rem',
              backgroundColor: '#666CFF',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#5156db',
              }
            }}
            disabled={
              errors.cpf != undefined ||
              errors.dataNascimento != undefined ||
              errors.email != undefined ||
              errors.nome != undefined ||
              errors.telefone != undefined ||
              errors.cep != undefined ||
              isDifferent && errors.cepEntrega != undefined ||
              telefoneJaExiste
            }
          > {loading ? <CircularProgress size={24} sx={{ color: 'white', marginRight: '0.3rem' }} /> : <></>}

            {isUpdateMode ? 'Atualizar' : (
              <>
                <AddIcon />
                Criar Cliente
              </>
            )}
          </Button>

          {isUpdateMode && (
            <Button
              variant='contained'
              className={styles.buttonRegisterCliente}
              onClick={criaNovoAtendimento}
              type='button'
              sx={{
                height: '2.5rem',
                width: '14rem',
                backgroundColor: '#666CFF',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#5156db',
                }
              }}
            >
              <AddIcon />
              Atendimento
            </Button>
          )}
        </div>
      </div>
    </form >
  )
}
